<template>
  <VueSidePanel
    v-model="isSidePanelOpen"
    transition-name="slide-right"
    width="62%"
    side="right"
    body-class="bbSidePanelBody"
    :z-index="5000"
  >
    <template #default>
      <div class="mt-2 px-4">
        <LogView />
      </div>
    </template>
  </VueSidePanel>
</template>

<script>
import LogView from '../views/LogView.vue'
import { VueSidePanel } from 'vue3-side-panel'
import 'vue3-side-panel/dist/vue3-side-panel.css'
//=========================================
// scripts
//---------
export default {
  name: 'LogSidePanel',
  //=========================================
  // components
  //------------
  components: {
    VueSidePanel,
    LogView,
  },
  //=========================================
  // data
  //------
  data() {
    return {
      isSidePanelOpen: true,
    }
  },
  //=========================================
  // watch
  //-------
  watch: {
    isSidePanelOpen(newValue) {
      if (!newValue) {
        if (this.$route.query?.popup) {
          const nextQuery = { ...this.$route.query }
          delete nextQuery.popup

          this.$router.replace({
            name: this.$route.name,
            params: this.$route.params,
            query: nextQuery,
          })
        } else {
          this.$router.go(-1)
        }
      }
    },
  },
}
</script>
